import React, { useEffect, useState } from 'react'
import Shearchbar from './Shearchbar'
import Navbar from './Navbar'
import Footer from './Footer';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import secureLocalStorage from "react-secure-storage";
import axios from 'axios'
import { useNavigate } from 'react-router-dom';
import Manubar from './Manubar';
const Offer = () => {
let navigate=useNavigate()
    const CustomPrevArrow = (props) => (
        <button
            className="custom-prev-arrow common-swiper-button-next"
            style={{ right: "60px", top: "-50px", padding: "5px", zIndex: "0" }}
            onClick={props.onClick}>
            <i className="las la-angle-left" style={{ color: "black", border: "1px solid", padding: "5px", borderRadius: "20px", zIndex: "0" }} />
        </button>
    );

    const CustomNextArrow = (props) => (
        <button
            className="custom-next-arrow common-swiper-button-next"
            style={{ right: "20px", top: "-50px", padding: "5px", zIndex: "0" }}
            onClick={props.onClick}
        >
            <i className="las la-angle-right" style={{ color: "black", border: "1px solid", padding: "5px", borderRadius: "20px", zIndex: "0" }} />
        </button>
    );


    const settings = {
        autoplay: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };
    let token = secureLocalStorage.getItem("n_token");
    let [showoffer, setshowoffer] = useState([])
    useEffect(() => {
        try {
            axios.get(`${process.env.REACT_APP_API}website/offer_list`, {
                headers: {
                    "token": token,
                }
            }).then((res) => {
                //console.log(res)
                setshowoffer(res.data.data)
            }).catch((error) => {
                console.log(error)
            })
        } catch (error) {
            
        }
     
      //  console.log(showoffer)
    }, [showoffer])

    let redeem=(promocode,offerprice)=>{
     console.log(promocode,"promocode")
     console.log(offerprice,"offerprice")
     secureLocalStorage.setItem("n_promocode",promocode)
     secureLocalStorage.setItem("n_offerprice",offerprice)
     navigate(`/cardlist`)
     
    }
    return (
        <div>

            <div>
                {/* header section start */}
                {/* Modal */}
                <div className="modal fade offcanvas-modal" id="exampleModal">
                    <div className="modal-dialog offcanvas-dialog">
                        <div className="modal-content">
                            <Manubar/>
                        </div>
                    </div>
                </div>
                <header>
                  
                    {/* header top end */}
                    <Shearchbar />
                    {/* header middle end */}
                    <Navbar />
                    {/* header middle end */}
                </header>
                {/* header section end */}
                {/* main content start */}
                {/* bread crumb section start */}
                <nav className="breadcrumb-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <ol className="breadcrumb bg-transparent m-0 p-0 align-items-center">
                                    <li className="breadcrumb-item"><a href="index.html">Home</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Coupan page </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </nav>
                {/* bread crumb section end */}
                <section className="featured-carousel-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="section-title">
                                    <h2 className="title">Coupan Offers</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 row">

                                {showoffer?.map((items)=>{
                                    return(
                                        <div className="product-card-list col-lg-3 col-md-4 col-sm-12">
                                        {/* product-card start */}
                                        <div className="product-card" style={{zIndex:"0"}}>
                                            {/*  <span class="badge bg-success product-badge">new</span> */}
                                            <div className="">
                                                <div className='text-center'>
                                                    <img className="product-image"  src={`${process.env.REACT_APP_API}uploads/${items.image}`}
                                                    width={"30%"} alt="image_not_found"/>
                                                </div>
                                                {/* <ul class="actions">
                               <li class="action whish-list">
                                   <button data-bs-toggle="modal" data-bs-target="#product-modal-wishlist"><i class="lar la-heart"></i></button>
                               </li>
                               <li class="action compare">
                                   <button data-bs-toggle="modal" data-bs-target="#product-modal-compare"></button>
                               </li>
                               <li class="action quick-view">
                                   <button data-bs-toggle="modal" data-bs-target="#product-modal"><i class="las la-eye"></i></button>
                               </li>
                           </ul> */}
                                            </div>
                                            <div className="product-content">
                                                <h4 className="product-title"><a href="#">{items.title}</a></h4>
                                                <h5 className><a href="#">Start-Date :{items.start_date}</a></h5>
                                                <h5 className><a href="#">Expir-Date :{items.expiry_date}</a></h5>
                                                <h6 className><a href="#">Promo-Code :{items.promo_code}</a></h6>
                                                <h6 className><a href="#">price :{items.price}</a></h6>
                                                <h6 className><a href="#">{items.description}</a></h6>
                                                {/* <div className="product-price-wrapp">
                                                    <span className="badge bg-success">*T&amp;C</span>
                                                </div> */}
                                                <div className="product-cart-btn-wrap">
                                                    <button className="btn btn-dark add-to-cart-btn"  onClick={()=>redeem(items.promo_code,items.price)}>Redeem</button>
                                                </div>
                                            </div>
                                        </div>
                                        {/* product-card end */}
                                    </div>
                                    )
                                })}
                                   

                            </div>
                        </div>
                    </div>
                </section>
                {/* news letter section start */}
                <section className="news-letter-sectoin bg-success">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-8 col-xl-9">
                                <div className="news-letter-wrap">
                                    <div className="news-letter-title">
                                        <h3 className="title">DOWNLOAD OUR APP</h3>
                                        <p>Download now to get more offers.</p>
                                    </div>
                                    {/* <form id="mc-form" class="news-letter-form" action="#">
							<input id="mc-email" class="form-control" name="email" type="email" placeholder="Your email address">
							<button class="sign-up-btn" type="submit">Sign up</button>
						</form> */}
                                </div>
                            </div>
                            <div className="col-lg-4 col-xl-3">
                                <div className="text-center text-lg-end mt-7 mt-lg-0">
                                    <a className="store-btn" href="#">
                                        <img src="assets/images/icon/app_store.png" alt="images_not_found" />
                                    </a>
                                    <a className="store-btn" href="#">
                                        <img src="assets/images/icon/google_play.png" alt="images_not_found" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* news letter section end */}
                {/* service section start */}
                <section className="service-section section-mt section-mb">
                    <div className="container">
                        <div className="services">
                            <div className="row mb-n7">
                                <div className="col-sm-6 col-lg-3 mb-7">
                                    <div className="service-item">
                                        <img className="service-icon" src="assets/images/icon/service1.png" alt="images_not_found" />
                                        <h3 className="service-title">100% SECURE PAYMENTS</h3>
                                        <p>Moving your card details to a much more secured place</p>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-lg-3 mb-7">
                                    <div className="service-item">
                                        <img className="service-icon" src="assets/images/icon/service2.png" alt="images_not_found" />
                                        <h3 className="service-title">TRUSTPAY</h3>
                                        <p>100% Payment Protection. Easy Return Policy</p>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-lg-3 mb-7">
                                    <div className="service-item">
                                        <img className="service-icon" src="assets/images/icon/service3.png" alt="images_not_found" />
                                        <h3 className="service-title">HELP CENTER</h3>
                                        <p>GGot a question? Look no further.Browse our FAQs or submit your query here.</p>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-lg-3 mb-7">
                                    <div className="service-item">
                                        <img className="service-icon" src="assets/images/icon/service4.png" alt="images_not_found" />
                                        <h3 className="service-title">Express Shipping</h3>
                                        <p>Fast, reliable delivery from global warehouses</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* service section end */}
                {/* footer section start */}
                <Footer />
            </div>



        </div>
    )
}

export default Offer